import type { ApiHook } from 'utils/request/useApi';
import type { Extension } from '../../ExtensionsModel';

export function getExtensionDetails(
  api: ApiHook,
  extensionId: string,
): Promise<Extension> {
  return api.request({
    method: 'GET',
    url: `extensions/${extensionId}`,
  });
}
